import { SendCodeButtonProps } from "@shared/features/onboarding/types";
import Link from "common/Typography/Link";
import InfoCircleOutlined from "@ant-design/icons/InfoCircleOutlined";
import { typography } from "@shared/common/Themes/typography";
import Text from "common/Typography/Text";
import React from "react";
import styled from "styled-components";
import useConnectTelegram from "features/onboarding/methodSettings/signalsGroup/connectExternalAccount/useConnectTelegram";
import Tooltip from "common/Tooltips/Tooltip";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const SendCodeButton = ({
  onSendAuthCodeClick,
  showCodeSent,
  codeSentTooltipText,
  showResendCode,
}: SendCodeButtonProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  const { setLocalStorageKey } = useConnectTelegram();

  let sendAuthCodeText = (
    <SendAuthCodeWrapper
      onClick={() => {
        setLocalStorageKey();
        onSendAuthCodeClick();
      }}
    >
      <Link>{t("external_account.send_code.get_code")}</Link>
    </SendAuthCodeWrapper>
  );

  if (showCodeSent) {
    const infoIcon = (
      <Tooltip
        title={codeSentTooltipText}
        placement="top"
        showMobileBottomDrawer={true}
      >
        <InfoCircleOutlined
          style={{ padding: "8px 0 8px 8px", fontSize: typography.fontSizes.S }}
        />
      </Tooltip>
    );
    sendAuthCodeText = (
      <SendAuthCodeWrapper>
        <Text type="secondary">
          {t("external_account.send_code.code_sent")} {infoIcon}
        </Text>
      </SendAuthCodeWrapper>
    );
  } else if (showResendCode) {
    sendAuthCodeText = (
      <SendAuthCodeWrapper onClick={onSendAuthCodeClick}>
        <Link>{t("external_account.send_code.resend_code")}</Link>
      </SendAuthCodeWrapper>
    );
  }

  return sendAuthCodeText;
};

export default SendCodeButton;

const SendAuthCodeWrapper = styled.div<{ onClick?: () => void }>`
  display: flex;
  align-items: center;
  ${(p) =>
    p.onClick &&
    `
  cursor: pointer;
  `}
`;
